import React from 'react'
import {FileUploader} from 'react-drag-drop-files'

type DragDropProps = {
  setFile: any
  label?: String
  fileTypes: string[]
  file?: File | null
  customDragDropSection?: React.ReactNode
}

function DragDrop({setFile, label, file, fileTypes, customDragDropSection}: DragDropProps) {
  const handleChange = (uploadedFile: any) => {
    setFile(uploadedFile)
  }
  console.log('internal file', file)
  return (
    <div>
      <FileUploader
        classes='h-150px bg-gray-100 border-gray-500 w-100'
        label={label}
        file={file}
        handleChange={handleChange}
        name='file'
        types={fileTypes}
      >
        {customDragDropSection}
      </FileUploader>
    </div>
  )
}

export default DragDrop
